module.exports = __webpack_public_path__ + "img/be531fc.png";